import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_LunchConsumptionChart = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_LunchConsumptionChart' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>LUNCH CONSUMPTION CHART</h3></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>CLIENT NAME:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>FACILITY:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtClientName' name='txtClientName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtFacility' name='txtFacility' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>DATE:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>DATE:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>DATE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='date' id='txtDateBirth1' name='txtDateBirth1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txtDateBirth2' name='txtDateBirth2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txtDateBirth3' name='txtDateBirth3' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>LUNCH</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>LUNCH</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>LUNCH</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <span className='eleHeader'>FOOD</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>CONSUMED</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>FOOD</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>CONSUMED</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>FOOD</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>CONSUMED</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood' name='txtFood' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed' name='txtConsumed' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood1' name='txtFood1' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed1' name='txtConsumed1' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood2' name='txtFood2' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed2' name='txtConsumed2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood3' name='txtFood3' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed3' name='txtConsumed3' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood4' name='txtFood4' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed4' name='txtConsumed4' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood5' name='txtFood5' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed5' name='txtConsumed5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood6' name='txtFood6' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed6' name='txtConsumed6' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood7' name='txtFood7' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed7' name='txtConsumed7' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood8' name='txtFood8' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed8' name='txtConsumed8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood9' name='txtFood9' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed9' name='txtConsumed9' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood10' name='txtFood10' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed10' name='txtConsumed10' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood11' name='txtFood11' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed11' name='txtConsumed11' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood12' name='txtFood12' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed12' name='txtConsumed12' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood13' name='txtFood13' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed13' name='txtConsumed13' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood14' name='txtFood14' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed14' name='txtConsumed14' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <span className='eleHeader'>Snack:</span>
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtSnack' name='txtSnack' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Snack:</span>
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtSnack1' name='txtSnack1' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Snack:</span>
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtSnack2' name='txtSnack2' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>DATE:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>DATE:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>DATE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='date' id='txtDateBirth4' name='txtDateBirth4' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txtDateBirth5' name='txtDateBirth5' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txtDateBirth6' name='txtDateBirth6' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-125'>
                            <span className='eleHeader'>FOOD</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>CONSUMED</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>FOOD</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>CONSUMED</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>FOOD</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>CONSUMED</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood15' name='txtFood15' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed15' name='txtConsumed15' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood16' name='txtFood16' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed16' name='txtConsumed16' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood17' name='txtFood17' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed17' name='txtConsumed17' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood18' name='txtFood18' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed18' name='txtConsumed18' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood19' name='txtFood19' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed19' name='txtConsumed19' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood20' name='txtFood20' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed20' name='txtConsumed20' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood21' name='txtFood21' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed21' name='txtConsumed21' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood22' name='txtFood22' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed22' name='txtConsumed22' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood23' name='txtFood23' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed23' name='txtConsumed23' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood24' name='txtFood24' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed24' name='txtConsumed24' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood25' name='txtFood25' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed25' name='txtConsumed25' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood26' name='txtFood26' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed26' name='txtConsumed26' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood27' name='txtFood27' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed27' name='txtConsumed27' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood28' name='txtFood28' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed29' name='txtConsumed29' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood30' name='txtFood30' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed30' name='txtConsumed30' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <span className='eleHeader'>Snack:</span>
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtSnack3' name='txtSnack3' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Snack:</span>
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtSnack4' name='txtSnack4' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Snack:</span>
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtSnack5' name='txtSnack5' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>DATE:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>DATE:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>DATE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='date' id='txtDateBirth7' name='txtDateBirth7' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txtDateBirth8' name='txtDateBirth8' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txtDateBirth9' name='txtDateBirth9' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-125'>
                            <span className='eleHeader'>FOOD</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>CONSUMED</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>FOOD</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>CONSUMED</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>FOOD</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>CONSUMED</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood31' name='txtFood31' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed31' name='txtConsumed31' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood32' name='txtFood32' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed32' name='txtConsumed32' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood33' name='txtFood33' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed33' name='txtConsumed33' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood34' name='txtFood34' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed34' name='txtConsumed34' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood35' name='txtFood35' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed35' name='txtConsumed35' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood36' name='txtFood36' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed36' name='txtConsumed36' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood37' name='txtFood37' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed37' name='txtConsumed37' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood38' name='txtFood38' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed38' name='txtConsumed38' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood39' name='txtFood39' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed39' name='txtConsumed39' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood40' name='txtFood40' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed40' name='txtConsumed40' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood41' name='txtFood41' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed41' name='txtConsumed41' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood42' name='txtFood42' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed42' name='txtConsumed42' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood43' name='txtFood43' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed43' name='txtConsumed43' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood44' name='txtFood44' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed44' name='txtConsumed44' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood45' name='txtFood45' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed45' name='txtConsumed45' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <span className='eleHeader'>Snack:</span>
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtSnack6' name='txtSnack6' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Snack:</span>
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtSnack7' name='txtSnack7' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Snack:</span>
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtSnack8' name='txtSnack8' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>MEAL CHART</h3></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>CLIENT NAME:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>HOME:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtClientName1' name='txtClientName1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtHome' name='txtHome' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>DATE:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>DATE:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>DATE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='date' id='txtDateBirth10' name='txtDateBirth10' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txtDateBirth11' name='txtDateBirth11' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txtDateBirth12' name='txtDateBirth12' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>BREAKFAST</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>BREAKFAST</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>BREAKFAST</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <span className='eleHeader'>FOOD</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>CONSUMED</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>FOOD</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>CONSUMED</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>FOOD</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>CONSUMED</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood46' name='txtFood46' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed46' name='txtConsumed46' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood47' name='txtFood47' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed47' name='txtConsumed47' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood48' name='txtFood48' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed48' name='txtConsumed48' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood49' name='txtFood49' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed49' name='txtConsumed49' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood50' name='txtFood50' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed50' name='txtConsumed50' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood51' name='txtFood51' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed51' name='txtConsumed51' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood52' name='txtFood52' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed52' name='txtConsumed52' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood53' name='txtFood53' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed53' name='txtConsumed53' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood54' name='txtFood54' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed54' name='txtConsumed54' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood55' name='txtFood55' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed55' name='txtConsumed55' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood56' name='txtFood56' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed56' name='txtConsumed56' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood57' name='txtFood57' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed57' name='txtConsumed57' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood58' name='txtFood58' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed59' name='txtConsumed59' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood60' name='txtFood60' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed60' name='txtConsumed60' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood61' name='txtFood61' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed61' name='txtConsumed61' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <span className='eleHeader'>Snack:</span>
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtSnack15' name='txtSnack15' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Snack:</span>
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtSnack16' name='txtSnack16' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Snack:</span>
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtSnack17' name='txtSnack17' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <span className='eleHeader'>LUNCH</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>CONSUMED</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>LUNCH</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>CONSUMED</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>LUNCH</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>CONSUMED</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood62' name='txtFood62' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed62' name='txtConsumed62' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood63' name='txtFood63' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed63' name='txtConsumed63' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood64' name='txtFood64' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed64' name='txtConsumed64' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood65' name='txtFood65' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed66' name='txtConsumed66' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood67' name='txtFood67' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed67' name='txtConsumed67' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood68' name='txtFood68' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed68' name='txtConsumed68' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood69' name='txtFood69' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed69' name='txtConsumed69' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood70' name='txtFood70' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed70' name='txtConsumed70' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood71' name='txtFood71' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed71' name='txtConsumed71' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood72' name='txtFood72' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed72' name='txtConsumed72' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood73' name='txtFood73' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed73' name='txtConsumed73' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood74' name='txtFood74' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed74' name='txtConsumed74' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood75' name='txtFood75' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed75' name='txtConsumed75' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood76' name='txtFood76' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed76' name='txtConsumed76' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood77' name='txtFood77' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed77' name='txtConsumed77' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <span className='eleHeader'>Snack:</span>
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtSnack9' name='txtSnack9' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Snack:</span>
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtSnack10' name='txtSnack10' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Snack:</span>
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtSnack11' name='txtSnack11' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <span className='eleHeader'>DINNER</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>CONSUMED</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>DINNER</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>CONSUMED</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>DINNER</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>CONSUMED</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood78' name='txtFood78' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed78' name='txtConsumed78' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood79' name='txtFood79' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed79' name='txtConsumed79' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood80' name='txtFood80' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed80' name='txtConsumed80' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood81' name='txtFood81' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed81' name='txtConsumed81' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood82' name='txtFood82' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed82' name='txtConsumed82' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood83' name='txtFood83' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed83' name='txtConsumed83' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood84' name='txtFood84' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed84' name='txtConsumed84' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood85' name='txtFood85' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed85' name='txtConsumed85' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood86' name='txtFood86' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed86' name='txtConsumed86' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood87' name='txtFood87' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed87' name='txtConsumed87' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood88' name='txtFood88' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed88' name='txtConsumed88' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood89' name='txtFood89' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed89' name='txtConsumed89' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtFood90' name='txtFood90' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed90' name='txtConsumed90' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood91' name='txtFood91' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed91' name='txtConsumed91' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtFood92' name='txtFood92' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtConsumed92' name='txtConsumed89' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <span className='eleHeader'>Snack:</span>
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtSnack12' name='txtSnack12' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Snack:</span>
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtSnack13' name='txtSnack13' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Snack:</span>
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtSnack14' name='txtSnack14' className='add-only' />
                        </td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











